module.exports = __webpack_public_path__ + "static/media/bg-cholesterol.b8a12da8.png";